// extracted by mini-css-extract-plugin
module.exports = {"collaboratorTitle":"collaboratorSettingDialog_collaboratorTitle__2rjXT","column":"collaboratorSettingDialog_column__8baVV","container":"collaboratorSettingDialog_container__-Wsn4","row":"collaboratorSettingDialog_row__Q2t63","btnDelete":"collaboratorSettingDialog_btnDelete__3POR0"};
    if(module.hot) {
      // 1783592040844
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  